/**
 * Reorder Master の /cart/add.js 422エラーをハンドリング
 *
 * 背景:
 *   HulkApps Reorder Master は商品単位の除外機能を持たない。
 *   一方で Order Limits アプリが初回購入限定商品（starter-set 等）の
 *   2回目以降購入を 422 で拒否する。Reorder Master 側は 422 を
 *   ハンドリングせず、ローディング表示のまま固まる。
 *
 * 対応:
 *   - window.fetch をフックし /cart/add.js の 422 を捕捉
 *   - エラーモーダル表示 + Reorder のローディング解除
 */
(function () {
  if (window.__reorderErrorHookInstalled) return;
  window.__reorderErrorHookInstalled = true;

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const [input] = args;
    const urlStr =
      typeof input === 'string' ? input : input && input.url ? input.url : '';
    const isCartAdd = urlStr.indexOf('/cart/add.js') !== -1;

    return originalFetch.apply(this, args).then((response) => {
      if (isCartAdd && response.status === 422) {
        response
          .clone()
          .json()
          .then((data) => {
            const msg =
              data.description ||
              data.message ||
              'カートへの追加に失敗しました';
            showReorderError(msg);
            hideReorderLoading();
          })
          .catch(() => {
            showReorderError('カートへの追加に失敗しました');
            hideReorderLoading();
          });
      }
      return response;
    });
  };

  const LOADER_SELECTOR =
    '#orderloading, .orderloading, #loadingvisiable, .hulk_loading';

  function forceHideLoaders() {
    document.querySelectorAll(LOADER_SELECTOR).forEach((el) => {
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('display', 'none', 'important');
    });
  }

  let loaderObserver = null;
  function hideReorderLoading() {
    forceHideLoaders();
    // 連続タイミングで再実行（Reorder Master が後から visible に戻すのに対抗）
    [50, 150, 300, 500, 1000, 2000].forEach((t) =>
      setTimeout(forceHideLoaders, t)
    );
    // MutationObserver: 該当要素の style/class 変更を即時上書き
    if (loaderObserver) loaderObserver.disconnect();
    loaderObserver = new MutationObserver(() => forceHideLoaders());
    document.querySelectorAll(LOADER_SELECTOR).forEach((el) => {
      loaderObserver.observe(el, {
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    });
    // 10秒後に監視解除
    setTimeout(() => {
      if (loaderObserver) {
        loaderObserver.disconnect();
        loaderObserver = null;
      }
    }, 10000);

    // ボタンを再活性化
    document
      .querySelectorAll('#add_to_card_button, #reorder_button')
      .forEach((btn) => {
        btn.disabled = false;
        btn.classList.remove('disabled', 'is-loading');
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
      });
  }

  function showReorderError(message) {
    let el = document.getElementById('reorder-custom-error');
    if (!el) {
      el = document.createElement('div');
      el.id = 'reorder-custom-error';
      el.setAttribute('role', 'alertdialog');
      el.style.cssText = [
        'position:fixed',
        'top:50%',
        'left:50%',
        'transform:translate(-50%,-50%)',
        'background:#fff',
        'border:2px solid #EB6130',
        'border-radius:12px',
        'padding:20px 24px',
        'max-width:92%',
        'width:420px',
        'box-shadow:0 12px 40px rgba(0,0,0,.25)',
        'z-index:2147483647',
        'font-family:inherit',
        'box-sizing:border-box',
      ].join(';');
      document.body.appendChild(el);
    }
    el.innerHTML =
      '<p style="margin:0 0 10px;font-weight:700;color:#EB6130;font-size:16px;">カートに追加できません</p>' +
      '<p style="margin:0 0 12px;font-size:14px;line-height:1.6;">' +
      escapeHtml(message) +
      '</p>' +
      '<p style="margin:0 0 16px;font-size:13px;color:#5F432E;line-height:1.6;">' +
      '該当する商品（スターターセット等の初回購入限定商品）を再注文一覧から削除のうえ、再度お試しください。' +
      '</p>' +
      '<button id="reorder-custom-error-close" style="' +
      'background:#5F432E;color:#fff;border:none;padding:10px 20px;border-radius:6px;cursor:pointer;font-size:14px;font-weight:600;' +
      '">閉じる</button>';
    el.style.display = 'block';
    const btn = document.getElementById('reorder-custom-error-close');
    if (btn) btn.addEventListener('click', () => el.remove(), { once: true });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[c]));
  }

  // custom-reorder.js（自前の再購入ボタン）からも同じエラーモーダルを使えるように公開
  window.__showReorderError = showReorderError;
})();
